import React from 'react';
import {Jobs} from './blocks';
import {JobDetailsData} from '@/pages/buddy/types/JobDetailsData';

interface JobsContentProps {
    jobs: JobDetailsData[];
    loading: boolean;
}

const JobsContent: React.FC<JobsContentProps> = ({
                                                     jobs,
                                                     loading,
                                                 }) => {
    return (
        <div>
            {/* Any additional content or components can be added here */}
            <Jobs jobs={jobs} loading={loading}/>
        </div>
    );
};

export {JobsContent};
